import React from 'react';

import { AddLessonButton } from 'components/AddLessonButton';

import { Lessons } from '../Lessons';

import styles from './LessonsSettings.module.scss';

const LessonsSettings = ({
  courseReadOnly,
  lessons,
  courseType,
  onEditLessonClick,
  onRemoveLessonClick,
}: {
  courseReadOnly: any;
  lessons: any;
  courseType: any;
  onEditLessonClick: any;
  onRemoveLessonClick: any;
}) => (
  <div className={styles.settings}>
    <Lessons
      courseReadOnly={courseReadOnly}
      lessons={lessons}
      onEditLessonClick={onEditLessonClick}
      onRemoveLessonClick={onRemoveLessonClick}
    />
    <AddLessonButton
      buttonClassName={styles.button}
      lessons={lessons}
      courseType={courseType}
    />
  </div>
);

export default React.memo(LessonsSettings) as any;
